import React from 'react'
import { MeetingLanguage } from '../../../../../models/Room'
import { getContactLanguageLabel, getContactLanguageLabelShort, getLanguageLabel, getLanguageShortLabel } from '../../../../../common/languageUtils'
import { UserLanguage } from '../../../../../models/User'

export interface LanguageDisplayProps {
  language?: MeetingLanguage
  shortLabel?: boolean
}

export const MeetingLanguageDisplay: React.FC<LanguageDisplayProps> = ({ language, shortLabel }) => {
  const languageLabel = shortLabel ? getLanguageShortLabel(language) : getLanguageLabel(language)

  if (!languageLabel) {
    return null
  }

  return (
    <div className='d-flex gap-2'>
      <i className='bi bi-globe2' />
      <div className='paragraph-medium'>{languageLabel}</div>
    </div>
  )
}

export interface ContactLanguageDisplay {
  language?: UserLanguage
  shortLabel?: boolean
}

export const ContactLanguageDisplay: React.FC<ContactLanguageDisplay> = ({ language, shortLabel }) => {
  const languageLabel = shortLabel ? getContactLanguageLabelShort(language) : getContactLanguageLabel(language)

  if (!languageLabel) {
    return null
  }

  return (
    <div className='d-inline-flex align-items-center flex-shrink-0'>
      <i className='bi bi-globe2'></i>
      <span className='paragraph-medium ps-1'>{languageLabel}</span>
    </div>
  )
}
